import { logRequestFailure } from '@/helpers/request-outcome'
import { api } from '@/helpers/apiClient'
import { pageQuery } from '@/lib/pagination'
import { ownVendorReviewDtoSchema, ownVendorReviewListDtoSchema, type OwnVendorReviewDto, type OwnVendorReviewListDto } from '@lib/dto/vendor-review.dto'
import type { ReportVendorReviewInput, WriteVendorReviewReplyInput } from '@lib/input/vendor-review.input'
import type { IOwnReviewService } from '@/types/OwnReviewService.types'

/** The signed-in vendor company's own published reviews. */
class OwnReviewService implements IOwnReviewService {
  async list(page: number): Promise<OwnVendorReviewListDto> {
    try {
      return await api.get(`/vendor/reviews${pageQuery(page)}`, ownVendorReviewListDtoSchema)
    } catch (error) {
      logRequestFailure('Failed to list reviews', { page }, error)
      throw error
    }
  }

  async reply(reviewId: string, input: WriteVendorReviewReplyInput): Promise<OwnVendorReviewDto> {
    try {
      return await api.put(`/vendor/reviews/${reviewId}/reply`, input, ownVendorReviewDtoSchema)
    } catch (error) {
      logRequestFailure('Failed to reply to a review', { reviewId }, error)
      throw error
    }
  }

  async report(reviewId: string, input: ReportVendorReviewInput): Promise<OwnVendorReviewDto> {
    try {
      return await api.post(`/vendor/reviews/${reviewId}/report`, input, ownVendorReviewDtoSchema)
    } catch (error) {
      logRequestFailure('Failed to report a review', { reviewId }, error)
      throw error
    }
  }
}

export const ownReviewService = new OwnReviewService()
